"use client"

import { useState } from "react"
import posthog from "posthog-js"

import { Button } from "@/components/ui/Button"
import { WaitlistModal } from "@/components/WaitlistModal"
import { isZenthorLaunched, zenthorCtaHref } from "@/lib/zenthor-launch"

const CONTACT_HREF = "/contato"

function track(ctaName: string) {
  if (process.env.NEXT_PUBLIC_POSTHOG_TOKEN) {
    posthog.capture("comparison_cta_clicked", { cta_name: ctaName })
  }
}

// VOR-104 / KAN-724 — pré-lançamento o botão abre o `WaitlistModal`.
// Pós-lançamento (`NEXT_PUBLIC_ZENTHOR_LAUNCHED=true`) o mesmo CTA vira
// link direto pro signup do produto.
export function CtaButtons() {
  const [waitlistOpen, setWaitlistOpen] = useState(false)
  const launched = isZenthorLaunched()
  const primaryLabel = launched
    ? "Criar conta no Zenthor"
    : "Entrar na lista do Zenthor"

  return (
    <>
      <div className="flex flex-wrap items-center justify-center gap-4">
        {launched ? (
          <Button variant="primary" href={zenthorCtaHref()}>
            {primaryLabel}
          </Button>
        ) : (
          <Button
            variant="primary"
            onClick={() => {
              track("waitlist_join")
              setWaitlistOpen(true)
            }}
          >
            {primaryLabel}
          </Button>
        )}
        {/* VOR-145: CTA ghost consome o Button do DS; dispara tracking no clique. */}
        <Button
          variant="ghost"
          href={CONTACT_HREF}
          onClick={() => track("contact_questions")}
        >
          Tirar dúvidas com a Vorseum
        </Button>
      </div>
      {!launched && (
        <WaitlistModal
          open={waitlistOpen}
          onClose={() => setWaitlistOpen(false)}
          source="comparativo"
        />
      )}
    </>
  )
}
